export class MacroSwapHelper {
    private static replaceTagMap: Map<string, string> =
        new Map([
            ["[timestamp]", "${CACHEBUSTER}"],
            ["[BID_ATTR.bid_id]", "${AUCTION_ID}"],
            ["[MM_UUID]", "${USER_ID}"],
            ["[ENCODED_CLICK_REDIRECT]", "${CLICK_URL_ENC}"],
            ["%c_esc", "${CLICK_URL_ENC}"],
            ["%c", "${CLICK_URL}"]
        ]);

    public static ReplaceTag(key: string, source: string): string {
        if (this.replaceTagMap.has(key)) {
            while (source.indexOf(key) != -1) {
                source = source.replace(key, this.replaceTagMap.get(key));
            }
        }

        return source;
    }

    public static FindReplaceableTags(source: string): { key: string, value: string }[] {
        let matches = Array.from(this.replaceTagMap.keys()).filter(key => source && typeof source !== 'undefined' && source?.indexOf(key) != -1).map(v => {
            return {
                key: v,
                value: this.replaceTagMap.get(v)
            }
        });

        // If we have matches we need to check if we have any substrings such as %c and %c_esc and we make sure the longer one has precedence.
        matches.forEach((map: { key: string, value: string }) => {
            var isKeySubString = matches.some(x => x.key.length > map.key.length && x.key.indexOf(map.key) != -1);
            if (isKeySubString) {
                matches = matches.filter(x => x.key !== map.key);
            }
        });

        return matches;
    }
}
